import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import './App.css'; // Asegúrate de que esta importación sea correcta
import logoHumen from './assets/logo_humen.png';
import { cardsData } from './data/cardsData';
import Nosotros from './components/Nosotros';
import Footer from './components/Footer';

function CardCarousel({ images }) {
  const [position, setPosition] = useState(0);
  const [isResetting, setIsResetting] = useState(false);

  useEffect(() => {
    const timer = setInterval(() => {
      if (!isResetting) {
        setPosition(prev => prev - 100);
      }
    }, 3000);

    return () => clearInterval(timer);
  }, [isResetting]);

  useEffect(() => {
    if (position <= -(images.length) * 100) {
      setIsResetting(true);
      setPosition(0);
      setTimeout(() => {
        setIsResetting(false);
      }, 50);
    }
  }, [position, images.length]);

  return (
    <div className="card-carousel">
      <div 
        className="carousel-inner" 
        style={{ 
          transform: `translateX(${position}%)`,
          transition: isResetting ? 'none' : 'transform 0.5s ease-in-out',
          display: 'flex'
        }}
      >
        {images.map((image) => (
          <div 
            key={image.id}
            style={{ minWidth: '100%' }}
            className="carousel-image-container"
          >
            <img 
              src={image.src} 
              alt={image.alt}
              className="carousel-image"
            />
          </div>
        ))}
      </div>
    </div>
  );
}

function Home() {
  return (
    <div className="main-container">
      <div className="cards-grid">
        {cardsData.map((card) => (
          <a
            key={card.id}
            href={card.link}
            target="_blank"
            rel="noopener noreferrer"
            className="card-link"
          >
            <div className="card">
              <div className="card-image">
                {card.images.length > 0 ? (
                  <CardCarousel images={card.images} />
                ) : (
                  <img src={card.images[0].src} alt={card.images[0].alt} />
                )}
              </div>
              <div className="card-content">
                <h3>{card.title}</h3>
                <p>{card.description}</p>
              </div>
            </div>
          </a>
        ))}
      </div>
    </div>
  );
}

function App() {
  return (
    <Router>
      <div className="app"> {/* Esta es la clase del contenedor de toda la app */}
        <nav className="nav-menu">
          <Link to="/" className="nav-logo">
            <img src={logoHumen} alt="Logo Humen" />
          </Link>
          <div className="nav-links">
            <Link to="/" className="nav-link">Inicio</Link>
            <Link to="/nosotros" className="nav-link">Nosotros</Link>
          </div>
        </nav>
        
        <main className="main-content">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/nosotros" element={<Nosotros />} />
          </Routes>
        </main>

        <Footer />
      </div>
    </Router>
  );
}

export default App;